import VoucherGroups from './Vouchers'

export default VoucherGroups;


// WEBPACK FOOTER //
// ./src/components/Query/Vouchers/index.ts